import React from 'react';
import { NavLink } from 'react-router-dom';
import { Routes } from '../../types/constants';
import styles from './AccountTabs.module.scss';

const tabs = [
    { label: 'Profile', route: Routes.PROFILE, end: true },
    { label: 'Billing', route: Routes.PROFILE_BILLING, end: false },
    { label: 'Manage account', route: Routes.PROFILE_MANAGE_ACCOUNT, end: false }
];

const AccountTabs = () => (
    <nav className={styles.tabs} aria-label="Account settings">
        {tabs.map((tab) => (
            <NavLink
                key={tab.route}
                to={tab.route}
                end={tab.end}
                className={({ isActive }) => isActive ? `${styles.tab} ${styles.activeTab}` : styles.tab}
            >
                {tab.label}
            </NavLink>
        ))}
    </nav>
);

export default AccountTabs;
